import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import ClientService from "../services/client.service";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import type { AppointmentConfirmationData } from "./models";

const getApiError = (err: unknown) => {
  if (typeof err !== "object" || err === null) {
    return null;
  }

  return err as {
    response?: {
      status?: number;
      data?: {
        errors?: {
          nonFieldErrors?: string[];
        };
      };
    };
  };
};

const CancelAppointment = () => {
  const { id } = useParams<{ id: string }>();
  const [statusData, setStatusData] = useState<AppointmentConfirmationData | null>(null);
  const [status, setStatus] = useState("new");
  const [error, setError] = useState<string | null>(null);
  const [isCanceling, setIsCanceling] = useState(false);

  const ErrorLabel = () => {
    if (error === "wrong status") {
      return <div>Appointment in wrong status, unable to cancel</div>;
    } else if (error === "already used") {
      return <div>Token to cancel appointment was already used</div>;
    } else {
      return <div>Appointment not found, please contact us</div>;
    }
  };

  const Content = () => {
    if (error) {
      return <ErrorLabel />;
    }

    if (status === "new") {
      return (
        <div>
          <div>Checking your data, please wait...</div>
          <div>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          </div>
        </div>
      );
    }

    if (status === "ready" && statusData) {
      return (
        <div>
          <div style={stylingObject.divs}>Hello {statusData.appointmentClient}</div>
          <div style={stylingObject.divs}>
            Are you sure to cancel your appointment on{" "}
            <b>{moment(statusData.appointmentDate).format("LLL")}</b>?<br/>
            If yes, please click cancel button:
          </div>
          <div style={stylingObject.divs}>
            <Button
              // style={stylingObject.buttonLeft}
              variant="danger"
              type="button"
              onClick={confirmCancel}
              disabled={isCanceling}
            >
              {isCanceling ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <span>Cancel</span>
              )}
            </Button>
          </div>
          <div style={stylingObject.divs}>
            If you would like to reschedule your appointment, please call{" "}
            <a href="tel:+19788950441">(978) 895-0441</a>
          </div>
        </div>
      );
    }

    if (status === "canceled" && statusData) {
      return (
        <div>
          <div>
            You canceled your appointment on{" "}
            <b>{moment(statusData.appointmentDate).format("LLL")}</b>
          </div>
          <div>
            If you would like to make a new appointment, please call{" "}
            <a href="tel:+19788950441">(978) 895-0441</a>
          </div>
        </div>
      );
    }

    return null;
  };

  const confirmCancel = async () => {
    setIsCanceling(true);
    try {
      if (!id) {
        setError("not found");
        return;
      }

      const response = await ClientService.cancelAppointment(id);
      if (response.status === 200) {
        setStatusData(response.data.data);
        setStatus("canceled");
      }
    } catch (error) {
      const apiError = getApiError(error);
      if (apiError?.response?.status === 400) {
        setError(apiError.response.data?.errors?.nonFieldErrors?.[0] ?? "error");
      } else if (apiError?.response?.data) {
        console.log(apiError.response.data);
      }
    } finally {
      setIsCanceling(false);
    }
  };

  useEffect(() => {
    const confirm = async () => {
      if (!id) {
        setError("not found");
        return;
      }

      try {
        const response = await ClientService.checkCancelAppointment(id);
        if (response.status === 200) {
          setStatusData(response.data.data);
          setStatus("ready");
        }
      } catch (error) {
        const apiError = getApiError(error);
        if (apiError?.response?.status === 400) {
          setError(apiError.response.data?.errors?.nonFieldErrors?.[0] ?? "error");
        } else if (apiError?.response?.data) {
          console.log(apiError.response.data);
        }
      }
    };
    confirm();
  }, [id]);

  return (
    <div className="col-md-12">
      <div style={stylingObject.center}>
        <img
          src="https://lirp.cdn-website.com/a85f75f8/dms3rep/multi/opt/LayoutsDB67747D-C218-0AC4-C1B8-2184CDD25E0F.png_400-356w.png"
          alt="profile-img"
          className="profile-img-card"
          width={200}
        />
        <Content />
      </div>
    </div>
  );
};

const stylingObject: Record<"center" | "divs", React.CSSProperties> = {
  center: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  divs: {
    padding: 5,
  },
};

export default CancelAppointment;
